import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { QUERY_PARAM } from "../../constants/queryParams";

const CaseStudyComponent = ({
  entries,
  handleLoadMore,
  hasMoreData,
  displayedEntriesCount,
  entriesToShow,
  setEntriesToShow,
  handleClearAll,
}) => {
  const [firstEntry, setFirstEntry] = useState(null);
  const [otherEntries, setOtherEntries] = useState([]);
  const { industriesCategoriesList } = useSelector((state) => state.caseStudy);

  useEffect(() => {
    if (entries.length > 0) {
      setFirstEntry(entries[0]);
      setOtherEntries(entries.slice(1));
    } else {
      setFirstEntry(null);
      setOtherEntries([]);
    }
  }, [entries]);

  const idsArray = industriesCategoriesList
    ? industriesCategoriesList.map((item) => item.id)
    : [];

  const handleLoadMoreClick = () => {
    handleLoadMore();
    setEntriesToShow(entriesToShow + 6);
  };

  const renderCategories = (categories) => {
    if (!categories || categories.length === 0) return null;

    return categories.map((cat, index) => (
      <React.Fragment key={cat.taxonomyCategoryId}>
        {cat.taxonomyCategoryName}
        {index < categories.length - 1 ? ", " : ""}
      </React.Fragment>
    ));
  };

  return (
    <div>
      {entries && entries.length > 0 ? (
        <>
          {firstEntry && (
            <div className="container">
              <a
                className="st-case-study-first-wrap"
                href={firstEntry.friendlyUrlPath}
              >
                <div className="row">
                  <div className="col-xl-6 col-lg-7 col-12">
                    <div className="st-case-study-img-wrap">
                      <img
                        src={
                          firstEntry?.contentFields?.find(
                            (item) => item.name === "thumbnailImage"
                          )?.contentFieldValue?.document?.contentUrl
                        }
                        alt="case-study"
                        className="st-item-img"
                        width="485"
                        height="345"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-5 col-12 align-self-end">
                    <div className="st-case-study-content-wrap">
                      <span className="medium-text-size d-block mb-21">
                        {renderCategories(
                          firstEntry?.taxonomyCategoryBriefs?.filter((cat) =>
                            idsArray.includes(String(cat.taxonomyCategoryId))
                          )
                        )}
                      </span>

                      <h2 className="st-case-study-title mb-24">
                        {
                          firstEntry?.contentFields?.find(
                            (item) => item.name === "successStoryTitle"
                          )?.contentFieldValue?.data
                        }
                      </h2>
                      <div
                        className="st-case-study-dic mb-24"
                        dangerouslySetInnerHTML={{
                          __html: firstEntry?.contentFields?.find(
                            (item) => item.name === "decryption"
                          )?.contentFieldValue?.data,
                        }}
                      />
                      <button className="common-xl-btn">Read Case Study</button>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          )}
          {otherEntries && otherEntries.length > 0 && (
            <section className="st-case-study-grid-section">
              <div className="container">
                <div className="row">
                  {otherEntries.slice(0, entriesToShow).map((entry, index) => (
                    <div
                      key={index}
                      className="st-case-study-list-wrapper col-lg-4 col-12"
                    >
                      <a
                        className="st-case-study-list-item-wrap"
                        href={entry.friendlyUrlPath}
                      >
                        <div className="st-case-study-list-inner">
                          <div className="st-case-study-list-img-wrap text-center poppins-bold">
                            <img
                              src={
                                entry?.contentFields?.find(
                                  (item) => item.name === "thumbnailImage"
                                )?.contentFieldValue?.document?.contentUrl
                              }
                              alt="case-study"
                              className="st-item-img"
                              width="485"
                              height="345"
                            />
                          </div>
                          <div className="st-case-study-list-content-wrap">
                            <span className="medium-text-size-span d-block mb-2">
                              {renderCategories(
                                entry?.taxonomyCategoryBriefs?.filter((cat) =>
                                  idsArray.includes(
                                    String(cat.taxonomyCategoryId)
                                  )
                                )
                              )}
                            </span>
                            <span className="st-text-black sub-title-small">
                              {
                                entry?.contentFields?.find(
                                  (item) => item.name === "successStoryTitle"
                                )?.contentFieldValue?.data
                              }
                            </span>
                            <div
                              className="d-lg-none d-block mb-21"
                              dangerouslySetInnerHTML={{
                                __html:
                                  entry?.contentFields?.find(
                                    (item) => item.name === "decryption"
                                  )?.contentFieldValue?.data || "",
                              }}
                            />

                            <span className="text-read-more-btn">
                              {
                                entry?.contentFields?.find(
                                  (item) => item.name === "readMoreButtonText"
                                )?.contentFieldValue?.data
                              }
                              <img
                                src="/documents/d/surekhatech/right-orange-arrow-1"
                                alt="right-arrow"
                              />
                            </span>
                          </div>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>

                {hasMoreData && displayedEntriesCount > entriesToShow && (
                  <div className="d-flex justify-content-center">
                    <button
                      id="view-more-btn"
                      className="common-xl-btn"
                      onClick={handleLoadMoreClick}
                    >
                      Load More
                    </button>
                  </div>
                )}
              </div>
            </section>
          )}
        </>
      ) : (
        <section className="page-not-found-section space-full">
          <div className="container">
            <div className="page-not-found-img-wrap">
              <img
                src="/documents/d/surekhatech/page-not-found"
                alt="page-not-found"
                width="788"
                height="630"
              />
            </div>
            <div className="page-not-found-content text-center">
              <h2>{QUERY_PARAM.NO_RESULTS_FOUND}</h2>
              <p>{QUERY_PARAM.NO_RESULTS_FOUND_DESCRIPTION}</p>
              <button
                className="common-xl-btn"
                onClick={() => handleClearAll()}
              >
                Try Again
              </button>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default CaseStudyComponent;
